import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AgreementApplicationState,
  AgreementForLoanMeta,
  AgreementSigningStatus,
  IdentityVerificationResultStateHelper,
  AppPageService,
  parseNumber,
  RouteHelper,
  SsoAccountData,
  SsoAccountFacade
 } from 'common';
import { take } from 'rxjs/operators';
import { EntityFacade } from '../../../entity/domain/+state/entity.facade';

@Injectable()
export class VerifyIdentityFacade {
  constructor(
    private readonly appPageService: AppPageService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly ssoAccountFacade: SsoAccountFacade,
    private readonly entityFacade: EntityFacade
  ) { }

  handleVerifyIdentitySuccessRedirect(currentAccount: SsoAccountData): void {
    this.ssoAccountFacade.clearSsoAccountCache();
    if (!this.appPageService.backToIfPossible(true)) {
      const companyId = parseNumber(RouteHelper.getQueryParamValueByName(this.route.snapshot, 'companyId'));
      this.entityFacade.getEntity$(companyId).pipe(take(1)).subscribe((entity) => {
        const entityId = entity?.id;
        
        // Check for pending MSA application for the current entity
        const pendingMsaApplication = this.findPendingMsaApplicationForEntity(currentAccount, entityId);
        if (pendingMsaApplication) {
          this.router.navigate([`application/${pendingMsaApplication.applicationId}/setup/sign-agreement`]);
          return;
        }

        // Check for pending loan agreement for the current entity
        const pendingLoan = this.findPendingLoanForEntity(currentAccount, entityId);
        if (pendingLoan) {
          this.router.navigate([`account/${pendingLoan.loanId}/setup/sign-agreement`]);
          return;
        }

        this.router.navigate(['home']);
      });
    }
  }

  private findPendingMsaApplicationForEntity(currentAccount: SsoAccountData, entityId: number | undefined): AgreementApplicationState | undefined {
    if (!entityId) {
      return undefined;
    }
    return currentAccount.pendingApplications?.find(app => 
      app.entityId === entityId && 
      app.agreementSigningStatus === AgreementSigningStatus.PendingCurrentUser
    );
  }

  private findPendingLoanForEntity(currentAccount: SsoAccountData, entityId: number | undefined): AgreementForLoanMeta | undefined {
    if (!entityId) {
      return undefined;
    }
    return currentAccount.loans?.find(loan => 
      loan.agreementState?.entityId === entityId && 
      loan.agreementState?.agreementSigningStatus === AgreementSigningStatus.PendingCurrentUser
    );
  }

  handleIdVerseFailedRedirect(isExpired: boolean): void {
    IdentityVerificationResultStateHelper.set({
      title: isExpired ? 'Verification expired' : 'Verification unsuccessful',
    });

    if(isExpired) {
      this.router.navigate(['account/setup/verify-identity-result'], { 
        replaceUrl: true,
      });
    } 
    else {
      this.router.navigate(['account/setup/verify-identity-result']);
    }
  }
}
